goog.provide("shadow.js.shim.module$dayjs$locale$sq");
goog.provide("module$shadow_js_shim_module$dayjs$locale$sq");
shadow.js.shim.module$dayjs$locale$sq = shadow.js.nativeProvides["dayjs/locale/sq"] = require("dayjs/locale/sq");
module$shadow_js_shim_module$dayjs$locale$sq.default = shadow.js.shim.module$dayjs$locale$sq;
